import { Field } from 'Util/Query';

export class StorePageQuery {

    StorePageQuery(store_id){
        return new Field('getStoresByFilters')
            .addArgument('filter','GetStoreFilterInput',{ store_id : { eq : store_id }})
            .addFieldList([this._getStoresField()]);
    }

    _getStoresField(){
        return new Field('item')
            .addFieldList(this._getStoresFieldItems());
    }

    _getStoresFieldItems(){
        return [
            'store_id',
            'category_id',
            'name',
            'address',
            'store_image',
            'postcode',
            'city',
            'region',
            'country',
            'phone',
            'email',
            'fax',
            'website',
            'open_hours',
            'static_block_1',
            'static_block_2',
            'url_alias',
            'banner_slider',
            'section_by_floor',
            'important_notices',
            'add_this_location',
            'popular_products',
            'categories',
            'brand_slider',
            'description',
            'meta_title',
            'meta_description',
            'meta_keywords',
            'embeded_map',
            'lat',
            'lng',
            'zoom'
        ];

    }

}

export default new StorePageQuery();
